import { createFileRoute } from "@tanstack/react-router";

import AvatarImageFormPage from "~/pages/user/AvatarImageFormPage.tsx";

export const Route = createFileRoute("/_auth/dashboard/user-settings/avatar")({
    component: AvatarImageFormPage,
});
